export const TextQaImg1 = () => {
  return (
    <div>
      <div className="image-filler"></div>
      <img
        style={{ borderRadius: "3px", overflow: "hidden" }}
        className="project-image"
        src="images/qa-opening.jpg"
        alt="image of project"
      />
    </div>
  );
};
